import React from "react";
import ".././../../styles/main.css";
import { LinearProgress, LinearProgressProps } from "@mui/material";

const ldnLinearProgress = (props: LinearProgressProps) => {
  return <LinearProgress {...props} />;
};

export default ldnLinearProgress;
